import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './presentation-item.scss.js';

class PresentationItem extends s {
    render() {
        return x `<div class="presentation-item ${this.rtl || isRTL() ? 'rtl' : ''}"><div class="date"><slot name="date"></slot></div><div class="title"><slot name="title"></slot></div><div class="materials"><slot name="material-item"></slot></div></div>`;
    }
}
PresentationItem.styles = css_248z;
__decorate([
    n({ type: Boolean })
], PresentationItem.prototype, "rtl", void 0);
customElements.define('presentation-item', PresentationItem);

export { PresentationItem };
